// extracted by mini-css-extract-plugin
module.exports = {"legend":"form-legend_legend__xo7TE token-typography-body-200 mds-typography-font-weight-semibold","badge":"form-legend_badge__EBC0b"};